<template>
  <svg
    fill="none"
    height="380"
    viewBox="0 0 348 380"
    width="348"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M174 -0.000579834V-0.000579834C174 13.9714 174 20.9573 176.144 26.516C179.395 34.9434 186.056 41.6044 194.483 44.8552C200.042 46.9994 207.028 46.9994 221 46.9994L300.499 46.9994C314.003 46.9994 320.755 46.9994 326.15 49.0047C334.873 52.2473 341.752 59.1266 344.995 67.8495C347 73.2441 347 79.9961 347 93.5V93.5"
      stroke="#E2E9F6"
    />
    <path
      d="M174 -6.10352e-05V-6.10352e-05C174 13.9719 174 20.9579 171.856 26.5166C168.605 34.944 161.944 41.6049 153.517 44.8557C147.958 47 140.972 47 127 47L47.5 47C33.9967 47 27.245 47 21.8506 49.0051C13.1273 52.2477 6.24772 59.1272 3.00516 67.8506C0.999998 73.245 0.999999 79.9966 1 93.5V93.5"
      stroke="#E2E9F6"
    />
    <path
      d="M174 0.000488281L174 380"
      stroke="#E2E9F6"
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpWhoIsForLinesTablet',
}
</script>